<!-- Wrapper -->
<div class="wrapper">
  <!-- Header -->
  @if (!hideHeader()) {
    <div class="header">
      <!-- Logo -->
      <div class="logo" *ngIf="!isScreenSmall">
        <img class="logo-text" src="assets/images/logo/ts-intapp-logo.svg" />
        <img class="logo-text-on-dark" src="assets/images/logo/logo-text-on-dark.svg" />
        <img class="logo-base" src="assets/images/logo/ts-intapp-logo.svg" />
      </div>
    </div>
  }

  <!-- Content -->
  <div class="content">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer
    <div class="footer">
        Intapp Properties &copy; {{currentYear}}
    </div>
     -->
</div>
